import { createStore, applyMiddleware } from 'redux'
import promise from 'redux-promise'

import rootReducer from '../reducers'

/**
 * Add all the state in local storage
 * @param getState
 * @returns {function(*): function(*=)}
 */
const localStorageMiddleware = ({ getState }) => next => (action) => {
    const result = next(action)
    localStorage.setItem('fai-applicationState-favoritePlants', JSON.stringify(getState().favoritePlants))
    return result
}

const reHydrateStore = () => {
    let favoritePlants
    if (localStorage.getItem('fai-applicationState-favoritePlants') !== null) {
        favoritePlants = JSON.parse(localStorage.getItem('fai-applicationState-favoritePlants'))
    }

    return favoritePlants ? { favoritePlants } : {} // re-hydrate the store
}

const createStoreWithMiddleware = createStore(
    rootReducer,
    reHydrateStore(),
    applyMiddleware(
        promise,
        localStorageMiddleware,
    )
)
const store = createStoreWithMiddleware

export default store



// WEBPACK FOOTER //
// ./src/store/index.js